import React, { useEffect } from "react";
import { MicroCoursBiaisConfirmation } from "../../modules/comprendre/MicroCours/MicroCoursBiaisConfirmation";
import { QuizBiaisConfirmation } from "../../modules/comprendre/Quiz/QuizBiaisConfirmation";
import { MixmindUniverse, useUniverse } from "../../context/UniverseContext";

// Academy – Apprendre : micro-cours et quiz réutilisés.
export default function AcademyApprendre() {
  const { setUniverse } = useUniverse();
  useEffect(() => {
    setUniverse(MixmindUniverse.Academy);
  }, [setUniverse]);

  return (
    <div className="max-w-5xl mx-auto space-y-8">
      <header className="space-y-2">
        <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-50 mb-4">Academy · Apprendre</h1>
        <p className="text-sm md:text-base text-slate-700 dark:text-slate-300">
          Micro-cours interactifs et quiz rapides pour ancrer les notions. Première démo : le biais de confirmation.
        </p>
      </header>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Micro-cours</h2>
        <MicroCoursBiaisConfirmation />
      </section>

      <section className="space-y-3">
        <h2 className="text-lg font-semibold">Quiz</h2>
        <QuizBiaisConfirmation />
      </section>
    </div>
  );
}
